import styled from "styled-components";

export const StatsSidebar = styled.div`
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	background-color: var(--white);
	box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);
	border-radius: 10px;
	overflow: hidden;
	margin-bottom: 16px;
	.statsBanner{
		display: flex;
		width: 100%;
		height: 90px;
		img{
			object-fit: cover;
			width: 100%;
			height: 100%;
		}
	}
	.statsContainer{
		display: flex;
		width: 100%;
		padding: 16px;
		flex-wrap: wrap;
		gap: 16px;
		.statsProfile{
			display: flex;
			gap: 16px;
			align-items: center;
			img{
				min-width: 48px;
				max-width: 48px;
			}
		}
		.statsWrapper{
			display: flex;
			width: 100%;
			justify-content: space-between;
			.statsWrapperInner{
				display: flex;
				width: fit-content;
				justify-content: center;
				flex-wrap: wrap;
				& > * {
					width: 100%;
					text-align: center;
				}
			}
		}
	}
`;
export const NavStatsSidebarContainer = styled.div`
	max-width: 300px;
	min-width: 300px;
	@media (max-width: 1199px) {
		max-width: 250px;
		min-width: 250px;
	}
`;
export const RightSidebarContainer = styled.div`
	max-width: 300px;
	min-width: 300px;
	@media (max-width: 1199px){
		display: none;
	}
	
`;

export const NavSidebarWrapper = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
	z-index: 190;
	box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);
	background-color: var(--white);
	transition: 0.3s all;
	border-radius: 10px;
	padding: 16px;
	a {
		position: relative;
		padding: 12px 15px;
		transition: all ease-in-out 0.3s;
		font-size: 15px;
		color: var(--lightGrey);
		border-radius: 10px;
		gap: 15px;
		svg {
			width: 22px;
			height: 22px;
		}
		&:hover,
		&.active {
			background-color: var(--themeColor);
			
			&::before {
				opacity: 1;
			}
			svg {
				[stroke] {
				stroke: var(--white);
				}
				[fill] {
				fill: var(--white);
				}
			}
			span {
				color: var(--white);
			}
		}
		.subArrow{
			body.rtl &{
				margin-right: auto;
				margin-left: 0 !important;
			}
			
			svg {
				[stroke] {
					stroke: var(--text2);
				}
				[fill] {
					fill: var(--text2);
				}
				
			}
		}
	}
	
	.sidebar-list {
		/* height: calc(100vh - 93px); */
		height: 100%;
		overflow-y: auto;
	}
	.close {
		width: 20px;
	}

	
`;

export const SuggestSidebar = styled.div`
	.suggestHeader{
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-bottom: 10px;
	}
	.followContainer{
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		.followContainerInner{
			display: flex;
			width: 100%;
			padding-top: 16px;
			padding-bottom: 16px;
			border-bottom: 1px solid var(--border);
			align-items: center;
			justify-content: space-between;
			gap: 10px;
		}
		.followProfile{
			display: flex;
			gap: 12px;
			align-items: center;
			text-align: left;
			img{
				min-width: 48px;
				max-width: 48px;
			}
			body.rtl & > *{
				text-align: right;
			}
		}
	}
`